(function () {
  var SIL = window.SILENTRIN || {}, V = SIL.variants || {}, A = function (f) { return (SIL.assets || "") + f; }, fmt = function (c) { return "$" + (c / 100).toFixed(2); };
  var KITS = {
    hush: { name: "The Hush", price: V.hush && +V.hush.price ? fmt(+V.hush.price) : "$49.99", img: A("kit-hush.jpg"), cap: "The Hush kit: mouthguard, calibration key and ventilated case.", alt: "The Hush kit: the mouthguard, its calibration key and the ventilated case, on a porcelain surface." },
    fresh: { name: "The Fresh", price: V.fresh && +V.fresh.price ? fmt(+V.fresh.price) : "$59.99", img: A("kit-fresh.jpg"), cap: "The Fresh kit: adds a dual-head cleaning brush.", alt: "The Fresh kit: the mouthguard, its calibration key, the ventilated case and a dual-head cleaning brush, on a porcelain surface." },
    ritual: { name: "The Ritual", price: V.ritual && +V.ritual.price ? fmt(+V.ritual.price) : "$79.99", img: A("kit-ritual.jpg"), cap: "The Ritual kit: adds the brush and a 50 kHz, 200 ml ultrasonic cleaner.", alt: "The Ritual kit: the mouthguard, its calibration key, the ventilated case, a dual-head cleaning brush and a round ultrasonic cleaner, on a porcelain surface." }
  };
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (id) { return document.getElementById(id); };
  var kit = "hush";
  document.documentElement.classList.add("js");
  var EASE = "cubic-bezier(.16, 1, .3, 1)";


  /* ---------- first slide and headline echo the ad the visitor came from (?ad=a1, ?utm_content=a1) ---------- */
  var qs = new URLSearchParams(location.search), adTag = (qs.get("ad") || qs.get("utm_content") || "").toLowerCase();
  if (adTag.charAt(0) === "a") {
    document.querySelectorAll('[data-hook="a"]').forEach(function (el) { el.classList.remove("is-off"); });
    var h1 = document.querySelector(".hero-head > h1"), lede = document.querySelector(".hero-head > .lede");
    if (h1) h1.textContent = "A different target: the jaw.";
  }

  /* ---------- carousel ---------- */
  var stage = $("stage"), tabsEl = $("tabs"), cap = $("cap");
  var slides = stage ? Array.prototype.slice.call(stage.children) : [];
  var tabs = tabsEl ? Array.prototype.slice.call(tabsEl.children) : [];
  var shown = function (el) { return el.offsetParent !== null; };
  function visibleSlides() { return slides.filter(shown); }
  function slideCap(s) { return s.id === "s-kit" ? KITS[kit].cap : (s.dataset.cap || ""); }
  function current() {
    var vs = visibleSlides(), w = stage.clientWidth || 1;
    return vs[Math.max(0, Math.min(vs.length - 1, Math.round(stage.scrollLeft / w)))];
  }
  function setCap(t) {
    if (cap.textContent === t) return;
    cap.textContent = t;
    if (!reduce && cap.animate) cap.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 260, easing: EASE });
  }
  function countUp(el) {
    var end = parseInt(el.dataset.to || el.textContent, 10); el.dataset.to = String(end);
    if (reduce) { el.textContent = end + "%"; return; }
    var t0 = performance.now(), dur = 1100;
    (function step(t) {
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 4);
      el.textContent = Math.round(end * e) + "%";
      if (p < 1) requestAnimationFrame(step);
    })(t0);
  }
  function sync() {
    var s = current(); if (!s) return;
    var i = slides.indexOf(s);
    slides.forEach(function (x) {
      var isCur = x === s;
      x.classList.toggle("cur", isCur);
      if (!x.classList.contains("slide-ev")) return;
      if (isCur && !x.dataset.played) {
        x.dataset.played = "1";
        x.querySelectorAll(".doc-l b").forEach(function (b, k) {
          b.dataset.to = String(parseInt(b.dataset.to || b.textContent, 10));
          if (!reduce) b.textContent = "0%";
          setTimeout(function () { countUp(b); }, 250 + k * 160);
        });
      } else if (!isCur && x.dataset.played) {
        delete x.dataset.played;
        x.querySelectorAll(".doc-l b").forEach(function (b) { if (b.dataset.to) b.textContent = b.dataset.to + "%"; });
      }
    });
    tabs.forEach(function (t, k) { if (k === i) t.setAttribute("aria-current", "true"); else t.removeAttribute("aria-current"); });
    setCap(slideCap(s));
    var vs = visibleSlides(), n = vs.indexOf(s) + 1;
    slides.forEach(function (x) { x.setAttribute("aria-label", (vs.indexOf(x) + 1) + " of " + vs.length); });
    var t = tabs[i];
    if (t && tabsEl.scrollWidth > tabsEl.clientWidth) tabsEl.scrollTo({ left: t.offsetLeft - (tabsEl.clientWidth - t.offsetWidth) / 2, behavior: reduce ? "auto" : "smooth" });
  }
  if (stage) {
    var raf = 0;
    stage.addEventListener("scroll", function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    tabs.forEach(function (t, k) {
      t.addEventListener("click", function () {
        var vs = visibleSlides(), pos = vs.indexOf(slides[k]);
        if (pos < 0) return;
        stage.scrollTo({ left: pos * stage.clientWidth, behavior: reduce ? "auto" : "smooth" });
      });
    });
    window.addEventListener("resize", function () { sync(); });
  }


  /* ---------- placeholders on / off ---------- */
  var ph = $("phToggle");
  if (ph) ph.addEventListener("change", function () {
    document.body.classList.toggle("no-ph", !ph.checked);
    stage.scrollTo({ left: 0, behavior: "auto" }); sync();
  });

  /* ---------- kit choice: both offer blocks stay in step ---------- */
  function setKit(k) {
    kit = k;
    document.querySelectorAll('input[name="kit"], input[name="kit2"]').forEach(function (r) { r.checked = (r.value === k); });
    document.querySelectorAll("[data-cta]").forEach(function (b) { if (!b.closest(".buybar")) b.textContent = "Add to cart · " + KITS[k].price; });
    if ($("barName")) { $("barName").textContent = KITS[k].name; $("barPrice").textContent = KITS[k].price; }
    var img = $("kitImg"), th = $("kitThumb");
    if (img) {
      img.src = KITS[k].img; img.alt = KITS[k].alt;
      if (!reduce && img.animate) img.animate([{ opacity: 0, transform: "scale(1.02)" }, { opacity: 1, transform: "none" }], { duration: 340, easing: EASE });
    }
    if (th) th.src = KITS[k].img;
    if (stage && $("s-kit") && current() === $("s-kit")) setCap(KITS[k].cap);
  }
  document.querySelectorAll('input[name="kit"], input[name="kit2"]').forEach(function (r) { r.addEventListener("change", function () { setKit(r.value); }); });

  document.querySelectorAll("[data-cta]").forEach(function (b) {
    b.addEventListener("click", function () {
      var label = b.textContent; b.setAttribute("aria-busy", "true"); b.textContent = "Adding…";
      setTimeout(function () {
        b.removeAttribute("aria-busy"); b.textContent = label;
        Promise.resolve(window.Cart ? window.Cart.add(kit) : null).then(function () {
          document.querySelectorAll("[data-status]").forEach(function (s) { s.innerHTML = 'Added to your cart. <button type="button" class="linkbtn" data-open-cart>View cart</button>'; s.classList.add("on"); });
          setTimeout(function () { document.querySelectorAll("[data-status]").forEach(function (s) { s.textContent = ""; s.classList.remove("on"); }); }, 4000);
        }, function () {});
      }, reduce ? 0 : 600);
    });
  });

  /* ---------- pinned buy bar: on screen whenever neither main button is (so on a phone it is there from the first screen) ---------- */
  var bar = $("buybar"), heroBtn = $("heroCta"), offerBtn = $("offerCta");
  if (bar && heroBtn) {
    var ticking = false;
    function upd() {
      ticking = false;
      var h = heroBtn.getBoundingClientRect(), o = offerBtn ? offerBtn.getBoundingClientRect() : null;
      var heroSeen = h.top < innerHeight && h.bottom > 0, offerSeen = o && o.top < innerHeight && o.bottom > 0;
      var show = !heroSeen && !offerSeen;
      bar.classList.toggle("on", show); bar.setAttribute("aria-hidden", show ? "false" : "true"); bar.querySelector("button").tabIndex = show ? 0 : -1;
    }
    var queue = function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } };
    window.addEventListener("scroll", queue, { passive: true }); window.addEventListener("resize", queue); window.addEventListener("load", queue); setTimeout(queue, 900); upd();
  }

  /* ---------- adjustment diagram, parts strip, deep links ---------- */
  /* one-shot reveals: the study bars and the guarantee stamp */
  var marked = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window) {
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("on"); rio.unobserve(e.target); } });
    }, { threshold: 0.5 });
    marked.forEach(function (el) { rio.observe(el); });
  } else { marked.forEach(function (el) { el.classList.add("on"); }); }
  var parts = $("parts");
  if (parts) parts.addEventListener("scroll", function () {
    var w = parts.querySelector("article").getBoundingClientRect().width + 20, n = Math.min(2, Math.round(parts.scrollLeft / w));
    document.querySelectorAll("#partDots li").forEach(function (d, i) { d.dataset.on = (i === n); }); $("partCount").textContent = (n + 1) + " of 3, swipe sideways";
  }, { passive: true });
  document.querySelectorAll("[data-open]").forEach(function (a) { a.addEventListener("click", function () { var d = $(a.dataset.open); if (d) d.open = true; }); });
  if (adTag.charAt(0) === "a" && stage) stage.scrollLeft = 0;   /* the drawer slide appears first: keep the carousel at its start */
  sync();
})();
